<header role="banner" aria-label="Main Navigation">
  <nav class="acessibilidade-menu">
    <ul class="acessibilidade-items">
      @for (opcao of menuTopo; track $index) {
        @if($index > 0) {
          <span style="color: white; padding-right: 1rem;">|</span>
        }
        <li>
          @if(opcao.rotaHref) {
          <a [id]="opcao.nome" tabindex="0" class="ajusta-font-size-acessibilidade" style="padding-right: 1rem;" [routerLink]="['.']"
            [fragment]="opcao.rotaHref">{{opcao.nome}}</a>
          } @else {
          <a [id]="opcao.nome" tabindex="0" class="ajusta-font-size-acessibilidade" style="padding-right: 1rem;" (click)="buttonAction(opcao)"
            (keyup.enter)="buttonAction(opcao)">{{opcao.nome}}</a>
          }
        </li>
      }
    </ul>
    <ul class="acessibilidade-items-right">
      <li style="margin-right: 1rem;">
        <img width="15" [src]="defaultContrastIcon ? '/icons/contrast-fill.svg' : 'icons/contrast-fill-reverse.svg'" tabindex="0" class="acessibilidade-icones-funcionais"
          [style]="defaultContrastIcon ? '' : 'background-color: white; border-radius: 50%;'"
          alt="Ícone do caractere 'A' em maíusculo seguido de um 'a' minúsculo." (click)="trocarTema()"
          (keyup.enter)="trocarTema()" />
      </li>
      <li>
        <img class="acessibilidade-icones-funcionais" tabindex="0" width="15" src="/icons/add-large-line.svg"
          alt="Botão de aumentar a fonte do sistema." (click)="aumentarTamanhoFonte()"
          (keyup.enter)="aumentarTamanhoFonte()" />
      </li>
      <li>
        <img width="15" src="/icons/font-size.svg"
          alt="Ícone do caractere 'A' em maíusculo seguido de um 'a' minúsculo." />
      </li>
      <li>
        <img class="acessibilidade-icones-funcionais" tabindex="0" width="24" src="/icons/subtract-line.svg"
          alt="Botão de diminuir a fonte do sistema." (click)="diminuirTamanhoFonte()"
          (keyup.enter)="diminuirTamanhoFonte()" />
      </li>
    </ul>
  </nav>

  <nav id="header-menu-principal" class="navegacao-menu">
    <ul class="header-items">
      @if(srcLogo && altLogo){
      <img class="logo-img" tabindex="0" style="cursor: pointer;" (click)="buttonAction(menus[0])" (keyup.enter)="buttonAction(menus[0])"
        [src]="srcLogo" [alt]="altLogo" />
      }
      @else {
      <span tabindex="0" style="cursor: pointer;" (click)="buttonAction(menus[0])"
        (keyup.enter)="buttonAction(menus[0])" style="background-color: gray;"> Logo </span>
      }

      <div class="menu-big-screen">
        @for (opcao of menus; track $index) {
        @if(!opcao.ocultarHeader) {
        <div class="d-inline-block main-option-menu" ngbDropdown #headerDropdown="ngbDropdown">
          @if(!opcao.subMenus) {
          <button type="button"
            class="btn btn-outline-default me-2 button-opcao-menu ajusta-font-size"
            id="dropdownManual" (click)="buttonAction(opcao)" (keyup.enter)="buttonAction(opcao)" ngbDropdownItem>
            {{opcao.nome}}
          </button>
          }
          @else {
          <button type="button" class="btn btn-outline-default me-2 button-opcao-menu ajusta-font-size"
            id="dropdownManual" ngbDropdownAnchor (click)="headerDropdown.open()" (keyup.enter)="headerDropdown.open()"
            (focus)="headerDropdown.open()">
            {{opcao.nome}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownManual" (mouseleave)="headerDropdown.close()">
            @for (opcaoSubmenu of opcao.subMenus; track $index){
            <button class="button-opcao-submenu ajusta-font-size" (click)="buttonAction(opcaoSubmenu)"
              (keyup.enter)="buttonAction(opcaoSubmenu)" ngbDropdownItem>
              {{opcaoSubmenu.nome}}
            </button>
            }
          </div>
          }
        </div>
        }
        }

        @if(!menuAreaCliente.ocultarHeader) {
          <div class="d-inline-block">
            <button type="button" class="btn btn-outline-default me-2 button-area-cliente" id="dropdownManual"
              (click)="buttonAction( menuAreaCliente)">
              <span class="ajusta-font-size area-cliente-button">
                <img style="margin-right: 0.5rem;" width="16vw" src="icons/user-3-line.svg"
                  alt="Um ícone simplificado representando um usuário." />{{ menuAreaCliente.nome}}
              </span>
            </button>
          </div>
          }
      </div>

      <div class="menu-small-screen">
        <div tabindex="0" (click)="toggleMenuHamburger()" (keyup.enter)="toggleMenuHamburger()" class="hamburger" id="hamburger"
        style="color: black;">
          &#9776;
        </div>

        <nav class="menu-small" id="menu-small">
          <ul>
          @for (opcao of menus; track $index) {
            @if(!opcao.ocultarHeader) {
              @if(!opcao.subMenus) {
                <li tabindex="0" (click)="buttonAction(opcao)" (keyup.enter)="buttonAction(opcao)">
                  <a>{{opcao.nome}}</a>
                </li>
              }
              @else {
                <li [id]="opcao.nome" tabindex="0" (click)="abrirSubMenu(opcao)" (keyup.enter)="abrirSubMenu(opcao)">
                  <a>{{opcao.nome}} <i class="fas fa-chevron-down" style="color: var(--tom-1-jornal)"></i></a>
                  <ul class="submenu-small">
                  @for (opcaoSubmenu of opcao.subMenus; track $index){
                    <li tabindex="0" (click)="buttonAction(opcaoSubmenu)" (keyup.enter)="buttonAction(opcaoSubmenu)">
                      <a>{{opcaoSubmenu.nome}}</a>
                    </li>
                    }
                  </ul>
                }
              }
            }

            @if(!menuAreaCliente.ocultarHeader) {
              <li tabindex="0" (click)="buttonAction(menuAreaCliente)" (keyup.enter)="buttonAction(menuAreaCliente)">
                <a style="padding-left: 14px; padding-right: 8px"><img width="16px" src="icons/user-3-line.svg"
                  alt="Um ícone simplificado representando um usuário." /> {{menuAreaCliente.nome}}</a>
              </li>
            }
          </ul>
        </nav>
      </div>
    </ul>
  </nav>
</header>
